import { InjectionToken } from '@angular/core';

export const COMMON_POPUP_DATA = new InjectionToken<any>('CommonPopupData');
